import { API } from "@/services"

export const USERS_ENDPOINTS = {
  list(params={}){
    return API.Axios.central_point.v2.request({
      url: `admin/users`,
      method: 'GET',
      params,
    })
  },
  add(data={}){
    return API.Axios.central_point.v2.request({
      url: `admin/users`,
      method: 'POST',
      data,
    })
  },
  remove(username,data={}){
    return API.Axios.central_point.v2.request({
      url: `admin/users/${username}`,
      method: 'DELETE',
      data,
    })
  },
  update(username,data={}){
    return API.Axios.central_point.v2.request({
      url: `admin/users/${username}`,
      method: 'PUT',
      data,
    })
  },
  get(username,params={}){
    return API.Axios.central_point.v2.request({
      url: `admin/users/${username}`,
      method: 'GET',
      params,
    })
  },
}